import { useEffect } from 'react'
import { Routes, Route, Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom'

import useFilterTabs from './hooks/useFilterTabs'

import CompanyManagement from 'pages/company-management/view/CompanyManagement'
import ManageLeaveCredit from 'module/leave/pages/adminLeaveSetting/view/manageLeaveCredit'
import ManageLeavePolicy from 'module/leave/pages/adminLeaveSetting/view/manageLeavePolicy'
import ManageOperationDay from 'module/leave/pages/adminLeaveSetting/view/manageOperationDay'
import EditOperationDay from 'module/leave/pages/editOperationDays/view'
import EditLeaveCredit from 'module/leave/pages/leaveCreditPolicy/view'
import CustomHolidayForm from 'module/leave/pages/editOperationDays/components/CustomHolidayForm'
import CreateLeavePolicyEntitlement from 'module/leave/pages/createLeavePolicy/view/withEntitlement'
import CreateLeavePolicyWithoutEntitlement from 'module/leave/pages/createLeavePolicy/view/withoutEntitlement'
import EditLeavePolicy from 'module/leave/pages/createLeavePolicy/view/edit'
import LeaveAllocationImport from 'module/leave/pages/leaveAllocationImport/view'
import LeaveAllocationTable from 'module/leave/pages/leaveAllocationImport/view/LeaveAllocationTable'
import LeaveDetailsTable from 'module/leave/pages/leaveDetailsRequirementImport/view/LeaveDetailsTable'
import ImportPayrollData from 'module/payroll/pages/payroll-configuration/components/ImportPayrollData'
import PreviewPayrollImport from 'module/payroll/pages/payroll-configuration/components/PreviewPayrollImport'
import LeaveDetailsRequirementImport from 'module/leave/pages/leaveDetailsRequirementImport/view'
import CreateForm from 'module/performance/pages/createForm/view'
import CreateEvaluation from 'module/performance/pages/appraisal-company-mgmt/view/CreateEvaluation'
import ViewEvaluation from 'module/performance/pages/appraisal-company-mgmt/view/ViewEvaluation'
import Alt2ViewForm from 'module/performance/pages/viewForm/view/formAlt2'
import EditForm from 'module/performance/pages/editForm/view'
import EditEvaluation from 'module/performance/pages/appraisal-company-mgmt/view/EditEvaluation'
import ShiftForm from 'module/time-attendance/view/settings/ShiftForm'

const CompanyManagementRoutes = () => {
  const location = useLocation()
  const { state } = location

  const navigate = useNavigate()

  // filtered tab will dynamically change based on backend permission
  const { filteredTabs } = useFilterTabs()

  // area to improve in the future
  useEffect(() => {
    const { pathname } = location
    const indexSlug = pathname?.split('/').indexOf('company-management') + 1
    const lastSlug = pathname?.split('/')[indexSlug]
    if (filteredTabs?.length > 0 && indexSlug && lastSlug) {
      const hasPermission = filteredTabs?.some((item) => item?.link === lastSlug)
      if (!hasPermission) {
        navigate('/app/management-centre/company-management')
      }
    }
  }, [filteredTabs, location, navigate])

  return (
    <>
      <Routes location={state?.backgroundLocation || location}>
        {filteredTabs?.map(({ link }, index) => {
          return (
            <>
              <Route index element={<Navigate to={link} />} />
              <Route path={link} element={<CompanyManagement initialTab={index} />} />
              {link === 'leave' && (
                <>
                  <Route path="leave" element={<Outlet />}>
                    <Route path="edit-operation-day" element={<EditOperationDay />} />
                    <Route path="edit-leave-credit" element={<EditLeaveCredit />} />
                    <Route
                      path="create-policy-entitlement"
                      element={<CreateLeavePolicyEntitlement />}
                    />
                    <Route
                      path="create-policy-without-entitlement"
                      element={<CreateLeavePolicyWithoutEntitlement />}
                    />
                    <Route path="edit" element={<Outlet />}>
                      <Route path=":id" element={<EditLeavePolicy />} />
                    </Route>
                  </Route>
                </>
              )}

              {/* Company Management -> Appraisal */}
              {link === 'appraisal' && (
                <>
                  <Route path="appraisal" element={<Outlet state={state} />}>
                    {/* Route for edit form */}
                    <Route path="form" element={<Outlet />}>
                      <Route path="create" element={<CreateForm />} />
                      <Route path="edit/:reportId" element={<EditForm />} />
                      <Route path="preview" element={<Outlet />}>
                        <Route path=":reportId" element={<Alt2ViewForm />} />
                      </Route>
                    </Route>

                    {/* Route for create & edit  evaluation */}
                    <Route path="evaluation" element={<Outlet />}>
                      <Route path="create" element={<CreateEvaluation />} />
                      <Route path="edit" element={<Outlet />}>
                        <Route path=":reportId" element={<EditEvaluation state={state} />} />
                      </Route>
                      <Route path="preview" element={<Outlet />}>
                        <Route path=":reportId" element={<ViewEvaluation state={state} />} />
                      </Route>
                    </Route>
                  </Route>
                </>
              )}
              {link === 'time-attendance' && (
                <>
                  <Route path="time-attendance" element={<Outlet state={state} />}>
                    <Route path="shift" element={<Outlet />}>
                      <Route path="create" element={<ShiftForm />} />
                      <Route path=":shiftId" element={<ShiftForm />} />
                    </Route>
                  </Route>
                </>
              )}
            </>
          )
        })}
      </Routes>
      {/* TODO remove for now for pithcing */}
      {/* Show the modal when a `backgroundLocation` is set
      {state?.backgroundLocation && (
        <Routes>
          <Route index element={<Navigate to="leave" />} />
          <Route path="leave" element={<Outlet />}>
            <Route path="operation-day" element={<ManageOperationDay />} />
            <Route path="edit-operation-day" element={<EditOperationDay />}>
              <Route path="create-custom-holiday" element={<CustomHolidayForm />} />
            </Route>

            <Route path={`:id`} element={<ManageLeavePolicy state={state} />} />
            <Route path="leave-credit-policy" element={<ManageLeaveCredit />} />
            <Route path="leave-allocation" element={<LeaveAllocationImport state={state} />} />

            <Route path="leave-allocation" element={<Outlet />}>
              <Route path="import" element={<LeaveAllocationTable state={state} />} />
            </Route>
            <Route path="leave-details" element={<LeaveDetailsRequirementImport state={state} />} />
            <Route path="leave-details" element={<Outlet />}>
              <Route path="import" element={<LeaveDetailsTable state={state} />} />
            </Route>
          </Route>
          <Route path="payroll" element={<Outlet />}>
            <Route path="import-payroll" element={<ImportPayrollData state={state} />} />
            <Route path="import-payroll" element={<Outlet />}>
              <Route path="import" element={<PreviewPayrollImport state={state} />} />
            </Route>
          </Route>
        </Routes>
      )} */}
    </>
  )
}

export default CompanyManagementRoutes
